import React, { useEffect, useRef } from 'react';
import { useDetailComponentData } from '@vendure/admin-ui/react';

const ENABLED_PRIORITIES = [20, 15];

const PriorityExpirationController = () => {
  const { detailForm } = useDetailComponentData();
  const subRef = useRef<any>(null);
  const retryRef = useRef<any>(null);

  useEffect(() => {
    if (!detailForm) return;

    const attach = (): boolean => {
      const priorityCtrl: any = detailForm.get(['customFields', 'priority']);
      const dateCtrl: any = detailForm.get(['customFields', 'priorityExpirationDate']);

      if (!priorityCtrl || !dateCtrl) return false;

      const apply = (value: any) => {
        const isEnabled = ENABLED_PRIORITIES.some(
          p => p === value || String(p) === String(value)
        );
        if (isEnabled) {
          if (dateCtrl.disabled) dateCtrl.enable();
        } else {
          if (dateCtrl.value) dateCtrl.setValue(null);
          if (!dateCtrl.disabled) dateCtrl.disable();
        }
      };

      apply(priorityCtrl.value);
      subRef.current = priorityCtrl.valueChanges.subscribe((v: any) => apply(v));
      return true;
    };

    if (!attach()) {
      // Form may not be fully built yet; retry briefly.
      let tries = 0;
      retryRef.current = setInterval(() => {
        tries += 1;
        if (attach() || tries >= 20) {
          clearInterval(retryRef.current);
          retryRef.current = null;
        }
      }, 100);
    }

    return () => {
      subRef.current?.unsubscribe?.();
      subRef.current = null;
      if (retryRef.current) {
        clearInterval(retryRef.current);
        retryRef.current = null;
      }
    };
  }, [detailForm]);

  return null;
};

export default PriorityExpirationController;
